
import { Card, CardContent } from "@/components/ui/card";

export function ErrorState() {
  return (
    <div className="container py-8">
      <Card>
        <CardContent className="p-8">
          <p className="text-center text-muted-foreground">
            Response not found
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
